import { render, staticRenderFns } from "./Data-settings.vue?vue&type=template&id=45388319"
import script from "./Data-settings.vue?vue&type=script&lang=js"
export * from "./Data-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports